import { DropdownListItem } from "@brg/ui";
import { Layout } from "_deziiign/main/pages/MainTagAdminPage/components/Layout";
import { LayoutConst } from "core";
import styled, { css } from "styled-components";

export const Wrapper = styled.div<{ isSelectPosition?: boolean }>`
    width: 100%;
    position: relative;

    .dropdown-element-popup {
        transform-origin: top;
        transform: scale(0);
        left: calc(100% - 10px);
        transform: translateX(10px);
        max-width: 300px;
    }

    svg {
        max-height: 16px;
        max-width: 16px;
        margin-left: 15px;
    }

    > div {
        width: 100%; 
    }

    ${DropdownListItem} {
        display: flex;
        flex-flow: row;
        justify-content: space-between;
        svg {
            fill: ${({ theme }) => theme.mainDropdownStyles?.color || '#151514'};
        }
    }

    @media(max-width: ${LayoutConst.screen.md}px) {
        .dropdown-element-popup {
            top: 54px;
            left: 20px !important;
        }
    }

    @media(max-width: ${LayoutConst.screen.sm}px) {
        .dropdown-element-popup {
            left: calc(100vw - 340px);
        }
    }

`;import { DropdownListItem } from "@brg/ui";
import { Layout } from "_deziiign/main/pages/MainTagAdminPage/components/Layout";
import { LayoutConst } from "core";
import styled, { css } from "styled-components";

export const Wrapper = styled.div<{ isSelectPosition?: boolean }>`
    width: 100%;
    position: relative;

    .dropdown-element-popup {
        transform-origin: top;
        transform: scale(0);
        left: calc(100% - 10px);
        transform: translateX(10px);
        max-width: 300px;
    }

    svg {
        max-height: 16px;
        max-width: 16px;
        margin-left: 15px;
    }

    > div {
        width: 100%; 
    }

    ${DropdownListItem} {
        display: flex;
        flex-flow: row;
        justify-content: space-between;
        svg {
            fill: ${({ theme }) => theme.mainDropdownStyles?.color || '#151514'};
        }
    }

    @media(max-width: ${LayoutConst.screen.md}px) {
        .dropdown-element-popup {
            top: 54px;
            left: 20px !important;
        }
    }

    @media(max-width: ${LayoutConst.screen.sm}px) {
        .dropdown-element-popup {
            left: calc(100vw - 340px);
        }
    }

`;